var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg879815(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6972DA"
    },
    d: "M451.938,374.154H156.023c-6.878,0-12.844-4.747-14.391-11.448L67.02,39.385H14.769 C6.613,39.385,0,32.772,0,24.616S6.613,9.846,14.769,9.846h64c6.878,0,12.844,4.747,14.391,11.448l74.612,323.321h284.166 c8.157,0,14.769,6.613,14.769,14.769C466.708,367.541,460.095,374.154,451.938,374.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1692FF"
    },
    d: "M508.764,74.466c-2.803-3.503-7.046-5.542-11.533-5.542H92.402c-4.501,0-8.756,2.052-11.558,5.575 s-3.845,8.13-2.833,12.515l45.444,196.923c1.547,6.701,7.514,11.448,14.391,11.448h315.077c6.908,0,12.893-4.788,14.409-11.527 L511.64,86.935C512.625,82.557,511.567,77.97,508.764,74.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6972DA"
    },
    d: "M216.615,393.846c-29.86,0-54.154,24.293-54.154,54.154c0,29.86,24.293,54.154,54.154,54.154 s54.154-24.293,54.154-54.154C270.769,418.14,246.476,393.846,216.615,393.846z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F5EC6"
    },
    d: "M393.846,393.846c-29.86,0-54.154,24.293-54.154,54.154c0,29.86,24.293,54.154,54.154,54.154 c29.86,0,54.154-24.293,54.154-54.154C448,418.14,423.707,393.846,393.846,393.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F5EC6"
    },
    d: "M451.938,344.616H256v29.538h195.938c8.157,0,14.769-6.613,14.769-14.769 C466.708,351.228,460.095,344.616,451.938,344.616z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007FDD"
    },
    d: "M497.231,68.923H256v226.462h196.923c6.908,0,12.893-4.788,14.409-11.527L511.64,86.935 c0.986-4.378-0.073-8.965-2.876-12.469C505.96,70.962,501.718,68.923,497.231,68.923z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg879815);
export default __webpack_public_path__ + "static/media/879815.a0b54405.svg";
export { ForwardRef as ReactComponent };